import { Component, Injector, OnInit } from '@angular/core';
import { UserService } from 'src/app/service/UserService';
import { BaseComponent } from '../../common/BaseComponent';
import { Observable, Subscription } from 'rxjs';

@Component({
  selector: 'app-my-services',
  templateUrl: './my-services.component.html',
  styles: [`
  .hover-link {
    padding: 10px;
  }

  .hover-div {
    display: none;
  }

  .hover-link:hover + .hover-div,
  .hover-div:hover {
    padding-top: 10px;
    font-size: 14px; 
    display: block;
  }
`]
})

export class MyServicesComponent extends BaseComponent implements OnInit {
    services:any[];
    servicesLength = 1;
    currentLanguage: string;
    private languageChangeSubs: Subscription;
    dataSubscription: Subscription;
  constructor(
    injector: Injector,
    public rest: UserService,
  ) {
    super(injector);
  }
  ngOnInit(): void {
    this.currentLanguage = this.translator.currentLang;
    this.subscribeToLanguageChange();
    this.dataSubscription = this.rest.getMyServices().subscribe((data:any)=>{
        this.services = data.services;
        this.servicesLength = data.services.length;
        if(this.services.length === 0){
          this.router.navigate(['secure/myServices/noServices']);
        }
    });
    
  }
  private subscribeToLanguageChange(): void {
    this.languageChangeSubs = this.translator.onLangChange.subscribe(
      () => {
        this.currentLanguage = this.translator.currentLang;
      }
    );
  }
  viewProfile() : void {
    this.router.navigate(['secure/profile']);
  }
  ngOnDestroy() {
    if (this.dataSubscription) {
      this.dataSubscription.unsubscribe();
    }
    if(this.languageChangeSubs){
      this.languageChangeSubs.unsubscribe();
    }
  }
}